import { ArrowRight, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const WHATSAPP_EXPERT = "https://wa.me/2250716421345?text=Bonjour, je souhaite parler à un expert santé";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[85vh] flex items-center justify-center overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_kacinoe-health-shop/artifacts/fka2s1f5_Skincare.png"
          alt="Couple heureux en bonne santé"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F5F0E8]/95 via-[#F5F0E8]/85 to-[#F5F0E8]/50 md:to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#F5F0E8] via-transparent to-[#F5F0E8]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 sm:py-20">
        <div className="max-w-2xl">
        <div className="fade-up">
          <span className="inline-block bg-white/80 backdrop-blur-sm text-[#6C3FC5] px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6 tracking-wide shadow-sm">
            Compléments alimentaires premium
          </span>
        </div>

        <h1
          className="fade-up fade-up-delay-1 text-3xl sm:text-5xl lg:text-6xl font-bold text-stone-900 leading-tight mb-4 sm:mb-6"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Prenez soin de vous,{" "}
          <span className="text-[#6C3FC5]">naturellement.</span>
        </h1>

        <p className="fade-up fade-up-delay-2 text-sm sm:text-base md:text-lg text-stone-700 max-w-lg mb-8 sm:mb-10 leading-relaxed">
          Découvrez notre gamme de compléments alimentaires certifiés, conçus
          pour renforcer votre santé et votre bien-être au quotidien. Livraison
          dans toute la Côte d'Ivoire.
        </p>

        <div className="fade-up fade-up-delay-3 flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
          <Link
            to="/produits"
            data-testid="hero-cta-products"
            className="inline-flex items-center gap-2 bg-[#6C3FC5] hover:bg-[#582FB0] text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-full text-sm sm:text-base font-medium transition-all duration-200 hover:scale-105 shadow-lg shadow-[#6C3FC5]/25 w-full sm:w-auto justify-center"
          >
            Voir les produits
            <ArrowRight size={18} />
          </Link>
          <a
            href={WHATSAPP_EXPERT}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-whatsapp"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-full text-sm sm:text-base font-medium transition-all duration-200 hover:scale-105 shadow-lg shadow-[#25D366]/25 w-full sm:w-auto justify-center"
          >
            <MessageCircle size={18} />
            Parler à un expert
          </a>
        </div>

        {/* Trust indicators */}
        <div className="fade-up fade-up-delay-4 flex items-center gap-4 sm:gap-6 mt-8 sm:mt-12 text-stone-600 text-xs sm:text-sm">
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-[#10B981]" />
            100% Naturel
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-[#6C3FC5]" />
            Certifié
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-[#F59E0B]" />
            Livraison CI
          </span>
        </div>
        </div>
      </div>
    </section>
  );
}
